import React from 'react';
import { Button } from '@fluentui/react-components';
import { Attach16Regular, DocumentText16Regular } from '@fluentui/react-icons';
import { GuideTooltip } from '../../../../theme/components/GuideTooltip';
import { useInvoicesText } from './PaymentInvoices.Bits';
import './PaymentInvoices.Styles.css';

export interface PaymentCountersProps {
    paymentId: number;
    /** undefined = todavía no se sabe (se ve al abrir el drawer). */
    invoiceCount?: number | null;
    receiptCount?: number | null;
    onInvoices: () => void;
    onReceipts: () => void;
    disabled?: boolean;
    /** Por qué no se puede (p. ej., el receptor no es un profesional). */
    disabledReason?: string;
}

const countText = (count: number | null | undefined, unknown: string) => (count === null || count === undefined ? unknown : String(count));

/**
 * Ícono con contador de facturas y de comprobantes de un pago; cada uno abre su drawer.
 * El número va en texto (el estado nunca depende sólo del color).
 */
export const PaymentCounters = ({ paymentId, invoiceCount, receiptCount, onInvoices, onReceipts, disabled, disabledReason }: PaymentCountersProps) => {
    const tr = useInvoicesText();
    const unknown = tr('counters.unknown');
    const invoices = countText(invoiceCount, unknown);
    const receipts = countText(receiptCount, unknown);
    const button = (key: 'invoices' | 'receipts', icon: JSX.Element, label: string, count: string, onClick: () => void) => {
        const aria = tr(`counters.${key}Aria`, { id: paymentId, count });
        return (
            <GuideTooltip content={disabled && disabledReason ? disabledReason : aria} relationship="description">
                <Button
                    appearance="subtle"
                    size="small"
                    icon={icon}
                    disabled={disabled}
                    aria-label={aria}
                    data-testid={`payment-${key}-${paymentId}`}
                    onClick={(event) => { event.stopPropagation(); onClick(); }}
                >
                    {label}
                    <span className="pinv-count ichtys-num" aria-hidden>{count}</span>
                </Button>
            </GuideTooltip>
        );
    };
    return (
        <span className="pinv-counters">
            {button('invoices', <DocumentText16Regular />, tr('counters.invoicesAction'), invoices, onInvoices)}
            {button('receipts', <Attach16Regular />, tr('counters.receiptsAction'), receipts, onReceipts)}
        </span>
    );
};

export default PaymentCounters;
